import WorkflowCode from "./WorkflowCodeEnum";
import IRedirectUrl from "./IRedirectUrl";
import IWorkflowStep from "./IWorkflowStep";

export default class WorkflowStep implements IWorkflowStep {
    constructor(
        public code: WorkflowCode,
        public mandatory: boolean,
        public priority: number,
        public redirect?: IRedirectUrl
    ) {
    }
}
